/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Drawer Header
  drawer_header: {
    app_name: "Lab Portal",
  },

  drawer_sections: {
    // Overview Section
    overview_section: {
      // Section Title
      title: "overview",

      // Overview Items
      drawer_items: {
        channels: {
          title: "Channels",
          tooltip_text: "Channel Status and Management",
        },
        validation: {
          title: "Validation",
          tooltip_text: "Result Validation",
        },
        allVisits: {
          title: "All Visits",
          tooltip_text: "View All Patient Visits",
        },
        newResults: {
          title: "New Results",
          tooltip_text: "Recently Received Results",
        },
        search: {
          title: "Search",
          tooltip_text: "Search Patients and Samples",
        },
        starred: {
          title: "Starred",
          tooltip_text: "Starred Items",
        },

        results: {
          title: "Results",
          tooltip_text: "Laboratory Results",
        },

        balance: {
          title: "Balance",
          tooltip_text: "Payment balance",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "About",
          tooltip_text: "About This Application",
        },
      },
    },

    // Dev Section (only visible when LAB_PORTAL_FE_DEV=true)
    dev_section: {
      title: "Developer",
      drawer_items: {
        uiStates: {
          title: "UI States",
          tooltip_text: "UI State Catalogue",
        },
      },
    },
  },
};
